import { Link } from "react-router-dom";
import { useLang, withLang, formatNumber, formatPrice } from "../i18n";
import { colors, fontHeading } from "../theme";
import { webpSmall } from "../imageUrls";

export default function CarCard({ car, index }) {
  const { t, lang } = useLang();
  const title = `${car.brand} ${car.model}`;
  const carPath = withLang(`/coche/${car.id}`, lang);

  return (
    // A real link to the car page, so search engines can follow it.
    <Link to={carPath} style={{ ...s.card, animationDelay: `${index * 0.06}s` }} className="car-card fade-in">
      <div style={s.imgWrap}>
        <picture>
          <source type="image/webp" srcSet={webpSmall(car.images[0])} />
          <img
            src={car.images[0]}
            alt={title}
            width={1600}
            height={1200}
            loading={index < 3 ? "eager" : "lazy"}
            decoding="async"
            style={s.img}
            className="car-card-img"
          />
        </picture>
        <div style={s.overlay} />
        <span style={s.yearBadge}>{car.year}</span>
      </div>
      <div style={s.body}>
        <p style={s.type}>
          {t.bodyTypeVals[car.bodyType]} · {t.fuelVals[car.fuel]}
        </p>
        <h3 style={s.name}>{title}</h3>
        <div style={s.specsRow}>
          <span style={s.specChip}>{formatNumber(car.km, lang)} km</span>
          <span style={s.specChip}>{t.transmissionVals[car.transmission]}</span>
          <span style={s.specChip}>{car.power} CV</span>
        </div>
        <div style={s.footer}>
          <span style={s.price}>{car.price ? formatPrice(car.price, lang) : t.consultPrice}</span>
          <span style={s.btn} className="btn-hover">
            {t.viewDetails} →
          </span>
        </div>
      </div>
    </Link>
  );
}

const s = {
  card: {
    display: "block",
    color: "inherit",
    textDecoration: "none",
    background: "#fff",
    border: `1px solid ${colors.border}`,
    overflow: "hidden",
    cursor: "pointer",
    animation: "fadeUp 0.6s ease both",
  },
  imgWrap: { position: "relative", overflow: "hidden", height: 220 },
  img: { width: "100%", height: "100%", objectFit: "cover", display: "block" },
  overlay: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(to top, rgba(0,0,0,0.28) 0%, transparent 45%)",
  },
  yearBadge: {
    position: "absolute",
    top: 14,
    right: 14,
    background: "#fff",
    color: colors.ink,
    fontSize: 12,
    fontWeight: 700,
    padding: "4px 11px",
    borderRadius: 3,
    fontFamily: fontHeading,
  },
  body: { padding: "20px 22px 24px" },
  type: {
    fontSize: 11,
    letterSpacing: "0.1em",
    color: colors.red,
    marginBottom: 6,
    fontFamily: fontHeading,
    fontWeight: 600,
    textTransform: "uppercase",
  },
  name: { fontSize: 20, fontWeight: 700, color: colors.ink, margin: "0 0 12px", fontFamily: fontHeading },
  specsRow: { display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 18 },
  specChip: {
    fontSize: 11.5,
    color: colors.body,
    background: colors.bgAlt,
    padding: "5px 10px",
    borderRadius: 20,
    fontWeight: 500,
  },
  footer: { display: "flex", justifyContent: "space-between", alignItems: "center" },
  price: { fontSize: 15, color: colors.ink, fontWeight: 700, fontFamily: fontHeading },
  btn: {
    background: "none",
    border: `1px solid ${colors.red}`,
    color: colors.red,
    padding: "8px 16px",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.06em",
    cursor: "pointer",
    fontFamily: fontHeading,
    borderRadius: 3,
  },
};
